import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KycComponent } from './kyc/kyc.component';
import { AdditionalInfoComponent } from './additional-info/additional-info.component';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AccountAggregatorComponent } from './account-aggregator/account-aggregator.component';
import { CurrentAddressComponent } from './current-address/current-address.component';
import { IncomeDetailsComponent } from './income-details/income-details.component';
import { BankInfoComponent } from './bank-info/bank-info.component';
import { VkycComponent } from './vkyc/vkyc.component';
import { ESignComponent } from './e-sign/e-sign.component';
import { EMandateComponent } from './e-mandate/e-mandate.component';
import { ProfessionalDetailsComponent } from './professional-details/professional-details.component';
import { ReferencesComponent } from './references/references.component';
import { PaymentComponent } from './payment/payment.component';
import { AssistLeftComponent } from '../assist-journey/assist-left/assist-left.component';
import { LeftIconsComponent } from './left-icons/left-icons.component';
import { CdnImageFinzyDirective } from 'src/app/core/directive/cdn-image-finzy.directive';


@NgModule({
  declarations: [
    AdditionalInfoComponent,
    KycComponent,
    AccountAggregatorComponent,
    CurrentAddressComponent,
    IncomeDetailsComponent,
    BankInfoComponent,
    VkycComponent,
    ESignComponent,
    EMandateComponent,
    ProfessionalDetailsComponent,
    ReferencesComponent,
    PaymentComponent,
    LeftIconsComponent,
    CdnImageFinzyDirective
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgxSpinnerModule
  ]
})
export class FinzyModule { }
